// Descarga de un fichero generado en el navegador (T4 del plan del change 003).
//
// La URL del blob se revoca SIEMPRE, también si algo falla: sin revocar, cada
// descarga retiene su fichero en memoria mientras viva la pestaña, y la oficina
// deja el panel abierto toda la jornada. No se revoca enseguida: hay navegadores
// que leen el blob después del clic y cortan la descarga si la URL ya no existe
// (FileSaver.js espera 40 s por eso). Solo Chromium está probado aquí; el minuto de
// margen cubre a los demás y retiene un solo fichero ese rato.
const ESPERA_PARA_REVOCAR_MS = 60_000;

export function descargarBlob(blob: Blob, nombre: string): void {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombre;
  enlace.hidden = true;
  document.body.append(enlace);
  try {
    enlace.click();
  } finally {
    enlace.remove();
    setTimeout(() => URL.revokeObjectURL(url), ESPERA_PARA_REVOCAR_MS);
  }
}
